<template >
  <div class="acuerdo">
    <main>
        <md-card md-with-hover v-if="showFluxer[0]">
            <md-card-header>
                <md-card-media>
                    <md-avatar>
                        <img :src="showFluxer[0].photoURL" alt="">
                    </md-avatar>
                </md-card-media>
                <md-card-header-text>
                    <div class="md-title name">
                        {{showFluxer[0].displayName}}
                    </div>
                    <div class="md-subhead">
                        <div >
                          <p style="color: black; font-weight: bold;" v-if="acuerdo.finalizado">Finalizado</p>
                          <p style="color: black; font-weight: bold;" v-if="acuerdo.sent && !acuerdo.finalizado">En Proceso</p>
                          <p style="color: black; font-weight: bold;" v-if="!acuerdo.sent">En Edicion</p>
                        </div>                   
                    </div>
                </md-card-header-text>
            </md-card-header>
        </md-card>
    </main>
  </div>
</template>


<script>
import FluxerService from '../services/fluxer'

export default {
  name: 'acuerdo',
  props: ['acuerdo', 'fluxer', 'texto'],
  data () {
    return {
      currentUser: FluxerService.getCurrentUser()
    }
  },
  firebase: function () {
    return {
      showFluxer: {
        source: FluxerService.getFluxerByEmail(this.fluxer)
      }
    }
  },
  methods: {
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-card .md-card-media img {
        border: solid lightslategray;
        border-radius: 100%;
    }

    .md-card {
        cursor: pointer;
        min-width: 328px;
    }

    .md-avatar {
        width: 80px;
        min-width: 80px;
        height: 80px;
        min-height: 80px;
        border-radius: 100%;
    }

    .md-card .md-card-header .md-card-header-text {
        margin-left: 20px;
    }

   .md-sidenav .md-sidenav-content {
        width: 50% !important;
    }

    .name {
        color: black;
    }

</style>



// WEBPACK FOOTER //
// Acuerdo.vue?25a66cd0